import { useNavigate } from "react-router-dom";
import { AlertCircle } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

export function CreditWarning() {
  const { user } = useAuth();
  const nav = useNavigate();
  if (!user || user.credits > 2) return null;
  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2 flex items-center justify-center gap-3" data-testid="credit-warning">
      <AlertCircle className="w-4 h-4 text-amber-600" />
      <span className="text-sm text-amber-800 font-medium">
        {user.credits === 0 ? "You're out of credits!" : `Only ${user.credits} credit${user.credits > 1 ? "s" : ""} left!`}
      </span>
      <button onClick={() => nav("/pricing")} className="text-xs font-bold text-amber-900 bg-amber-200 px-3 py-1 hover:bg-amber-300 transition-colors" data-testid="buy-credits-warning-btn">Buy Credits</button>
    </div>
  );
}
